import Component from '../colorz/Component';

export default class BookmarkButton extends Component {
	onInit(el) {
		this.el = el;
	}

	onReady() {
		this.el.addEventListener('click', () => {
			this.addToBookmark();
		});
	}

	addToBookmark() {
		alert(
			'Press ' +
				(navigator.userAgent.toLowerCase().indexOf('mac') != -1
					? 'Command/Cmd'
					: 'CTRL') +
				' + D to bookmark this page.',
		);
	}
}
